import React from 'react';
// import Header from "../../components/shared/Header";

import BookADemoForm from '../../components/BookADemo/BookADemoForm';
import AppNavbar from '../../components/Home/Navbar';
import Footer from '../../components/Home/Footer';
import StatsSection from './StatsSection';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Navigation, Pagination, Scrollbar , Autoplay } from 'swiper/modules';

const About = () => {

  return (
    <>
      <AppNavbar />
      <section className="bg-gray-100 min-h-[75vh] px-[50px] flex items-center">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-center md:space-x-8">
            
            {/* Left Side - Heading */}
            <div className="w-full md:w-1/2 md:text-left mb-8 md:mb-0">
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight text-gray-900">
                So how did <br />
                <span className="text-[rgb(10,192,171)]">abc.com</span><br />
                come to be?
              </h2>
            </div>

            {/* Right Side - Paragraph */}
            <div className="w-full md:w-1/2 text-xl text-gray-800">
              Well for us, it happened somewhere in between collaborating and communicating, engaging, and scaling rapidly. All while being totally transparent and working the way we want.
            </div>
          </div>
        </div>
      </section>



      <section
        className="relative bg-cover bg-center bg-no-repeat h-[90vh] flex items-center justify-start"
        style={{
          backgroundImage: "url('https://picsum.photos/1800/1000')", // Replace with your actual image
          backgroundAttachment: "fixed", // Parallax effect
        }}
      >
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/30"></div>

        {/* Text content */}
        <div className="relative z-10 max-w-4xl px-8 text-white">
          <h1 className="text-[6.75rem] font-extrabold leading-tight">
            It's all<br />about the<br />people
          </h1>
        </div>
      </section>

      <section className="bg-white-100 py-16">
        {" "}{/* Generous vertical padding */}
        <div className="container mx-auto px-4">
          {" "}{/* Centered container with horizontal padding */}
          <div className="flex flex-col md:flex-row items-center justify-center md:space-x-8">
            {" "}{/* Flex container for alignment, responsive direction, and spacing */}

            <div className="w-full md:w-1/2  md:text-left">
              {" "}{/* Column for text, responsive width, text alignment */}
              <p className="text-lg text-gray-600 mb-6">
                As we integrated and automated, built workflows, created templates, and expanded our community beyond our wildest expectations, we continued to grow. It is through this journey that the monday.com Work OS was born.
              </p>
            </div>
            <div className="w-full md:w-1/4 text-center mb-8 md:mb-0">
              {" "}{/* Column for image, responsive width, margin-bottom */}
              <img
                src="https://picsum.photos/400"
                alt="CTA Image"
                className="max-w-full h-auto mx-auto rounded-lg shadow-lg"
              />{" "}
            </div>
            <div className="w-full md:w-1/6 text-center mb-8 md:mb-0">
              {" "}{/* Column for image, responsive width, margin-bottom */}
              <img
                src="https://picsum.photos/400/600"
                alt="CTA Image"
                className="max-w-full h-auto mx-auto rounded-lg shadow-lg"
              />{" "}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-100 py-16">
        {" "}{/* Generous vertical padding */}
        <div className="container mx-auto px-4">
          {" "}{/* Centered container with horizontal padding */}
          <div className="flex flex-col md:flex-row items-center justify-center md:space-x-8">
            {" "}{/* Flex container for alignment, responsive direction, and spacing */}
            <div className="w-full md:w-1/2 text-center mb-8 md:mb-0">
              {" "}{/* Column for image, responsive width, margin-bottom */}
              <img
                src="https://picsum.photos/400"
                alt="CTA Image"
                className="max-w-full h-auto mx-auto rounded-lg shadow-lg"
              />{" "}
            </div>
            <div className="w-full md:w-1/2  md:text-left">
              {" "}{/* Column for text, responsive width, text alignment */}
              <p className="text-lg text-gray-600 mb-6">
                June 10th, 2021 marked the start of a new era for monday.com—we rang the opening bell and officially became a publicly traded company on Nasdaq.

                These days, we continue to fuel our growth by evolving into a multi-product company, providing people, teams, and companies powerful products to help turn their work visions into a reality. We’re only just getting started.
              </p>
            </div>

          </div>
        </div>
      </section>

      <section className="bg-gray-100 py-16">
        <div className="container mx-auto px-6">
          {/* Title */}
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900">
              Our story
            </h2>
          </div>

          {/* Swiper */}
          <div className="relative">
            <Swiper
              modules={[Navigation, Pagination, A11y, Autoplay]} // ✅ include Autoplay
              spaceBetween={30}
              slidesPerView={1}
              breakpoints={{
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              autoplay={{
                delay: 3000,      // ✅ 3 seconds between slides
                disableOnInteraction: false,
              }}
              navigation={{
                nextEl: ".custom-next",
                prevEl: ".custom-prev",
              }}
              pagination={{
                clickable: true,
                el: ".custom-pagination",
              }}
              className="pb-12"
            >
              {[...Array(6)].map((_, idx) => (
                <SwiperSlide key={idx}>
                  <div className="bg-white rounded-2xl shadow-md p-8 h-full flex flex-col items-center text-center hover:shadow-lg transition duration-300">
                    <div className="text-4xl mb-4">✨</div>
                    <h3 className="text-xl font-bold mb-2 text-[rgb(10,192,171)]">
                      Title of the Slide {idx + 1}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">
                      This is a short paragraph that describes what happened in this part of our story.
                      Add more info as needed to show meaningful events or company growth.
                    </p>
                    <span className="text-sm font-semibold text-gray-800 mt-auto">
                      April 2025
                    </span>
                  </div>
                </SwiperSlide>
              ))}

              {/* Custom Navigation Buttons */}
              <div className="custom-prev absolute left-[-1.5rem] top-1/2 transform -translate-y-1/2 z-10 cursor-pointer text-gray-700 hover:text-black text-2xl">
                &#8592;
              </div>
              <div className="custom-next absolute right-[-1.5rem] top-1/2 transform -translate-y-1/2 z-10 cursor-pointer text-gray-700 hover:text-black text-2xl">
                &#8594;
              </div>
            </Swiper>

            {/* Pagination Dots */}
            <div className="custom-pagination flex justify-center mt-6 space-x-2"></div>
          </div>
        </div>
      </section>
      
      <StatsSection />
      
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-extrabold leading-tight text-gray-900">
              Our culture and values
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {[
              {
                icon: "📊",
                title: "Data-Driven",
                description:
                  "Data is at the core of our identity both as a company and a team, enabling high-impact execution.",
              },
              {
                icon: "🎯",
                title: "Ownership and Impact",
                description:
                  "We take full responsibility and drive impact with autonomy and accountability.",
              },
              {
                icon: "🚀",
                title: "Speed and Execution",
                description:
                  "We move fast with purpose, optimizing execution without compromising quality.",
              },
              {
                icon: "📅",
                title: "Product-first",
                description:
                  "Our product is the heartbeat of our success and the center of every decision we make.",
              },
              {
                icon: "🟦🟥🟪",
                title: "Inclusivity",
                description:
                  "We celebrate diversity and strive to build a culture where everyone belongs and thrives.",
              },
              {
                icon: "💙",
                title: "Customer-Centricity",
                description:
                  "We put our customers at the center of everything to help them achieve more.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="relative bg-[#f5f7ff] rounded-xl p-6 group hover:shadow-lg transition-shadow duration-300"
              >
                <div className="text-4xl mb-4">{item.icon}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 h-0 group-hover:h-auto overflow-hidden">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white text-center">
  <div className="container mx-auto px-4">
    <h2 className="text-3xl sm:text-4xl font-extrabold mb-12 text-gray-900">
      Get to know us better
    </h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
      {[
        {
          icon: "https://cdn-icons-png.flaticon.com/512/5974/5974636.png", // Green megaphone
          tag: "Read",
          title: "monday.com in the news",
          desc: "Check out some of our favorite articles over the years!",
        },
        {
          icon: "https://cdn-icons-png.flaticon.com/512/5974/5974603.png", // Yellow mic
          tag: "Listen",
          title: "Startup for Startup podcast",
          desc: "Sharing insights, experience, and knowledge.",
        },
        {
          icon: "https://cdn-icons-png.flaticon.com/512/5974/5974592.png", // Pink blog
          tag: "Explore",
          title: "Our blog ‘stacks’ 📚",
          desc: "Customer stories, tips, and our opinions on everything in between.",
        },
      ].map(({ icon, tag, title, desc }, i) => (
        <div
          key={i}
          className="bg-white rounded-2xl shadow-lg p-6 transition hover:shadow-xl border border-gray-100"
        >
          <div className="flex justify-center mb-6">
            <div className="w-32 h-32 bg-[#f0f3ff] rounded-full flex items-center justify-center">
              <img src={icon} alt={tag} className="w-14 h-14" />
            </div>
          </div>
          <p className="text-sm font-semibold text-gray-700 mb-1">{tag}</p>
          <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
          <p className="text-gray-600 text-sm">{desc}</p>
        </div>
      ))}
    </div>
  </div>
</section>


      <section className="bg-[#0AC0AB] py-20 rounded-3xl mx-4 md:mx-16 my-12 relative overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-2xl">
            <h2 className="text-white text-3xl sm:text-5xl font-extrabold leading-tight mb-6">
              <span className="text-white">Together</span>{" "}
              <span className="font-black">we can impact</span>{" "}
              <span className="text-white">how teams work across the globe</span>
            </h2>
            <button className="bg-white text-gray-900 text-lg font-medium px-8 py-3 rounded-full shadow hover:shadow-lg transition">
              Join our team! <span className="ml-2">→</span>
            </button>
          </div>
        </div>

        {/* Decorative SVG/Shapes – mimic design from screenshot */}
        <div className="absolute right-0 top-0 h-full w-1/2 z-0 flex justify-end">
          <div className="bg-[#4426ff] rounded-full w-[500px] h-[500px] translate-x-1/4 translate-y-1/4"></div>
          <div className="absolute top-12 right-[30%] w-6 h-6 bg-[#7777ff] rounded-full opacity-80 shadow-lg"></div>
          <div className="absolute top-0 right-0 h-full w-1/2 bg-gradient-to-t from-[#3924ad] to-transparent rounded-l-[50%] opacity-40"></div>
        </div>
      </section>



      <Footer />
    </>
  );
};

export default About;
